import { ErrorMessage } from "@hookform/error-message";
import { Buffer } from "buffer";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { NumericFormat } from "react-number-format";
import QRCode from "react-qr-code";
import { useHistory, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Row, RSelect } from "../../components/Component";
import Pictures from "../../components/picture/Picture";
import { GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { ACTION_SCAN, INVENTORY_FUEL_CATEGORY } from "../../utils/Utils";



const INVENTORY_FUEL_CATEGORY_OPTIONS = Object.keys(INVENTORY_FUEL_CATEGORY).map((c) => ({
  label: INVENTORY_FUEL_CATEGORY[c],
  value: c,
}));

const DEFAULT_INVENTORY_OUT_INSIDE = {
  id: "",
  date: moment().format("YYYY-MM-DD HH:mm"),
  warehouseId: null,
  quantity: 0,
  truckId: "",
  userId: '',
  category: "OIL",
};

const UpsertInventoryOutInside = () => {
  const history = useHistory();
  const { search } = useLocation();
  const duplicateId = new URLSearchParams(search).get("duplicateId");
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [truckOptions, setTruckOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const id = duplicateId || params.id !== "add" ? params.id : "";
  const isEdit = !!id && id !== "add" && !duplicateId
  const [data, setData] = useState({});
  const methodForm = useForm({
    defaultValues: DEFAULT_INVENTORY_OUT_INSIDE,
  });
  const { errors, register, handleSubmit, reset, getValues, control, watch, setValue } = methodForm

  useEffect(() => {
    GET("truck", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });
    GET("/user/list-user-can-oil-out-inside", {}, true).then((resp) => {
      const { data } = resp;
      setDriverOptions(
        data.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])

  useEffect(() => {
    if (!id) {
      return;
    }
    GET(`inventory/out-inside-transaction/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
          date: moment(data.date).format("YYYY-MM-DDTHH:mm"),
          billPictures: data?.inventoryOutTransactionPicture?.map((c) => ({ src: c.src })) || []
        });
        setData(data)
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      });
  }, [id]);

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { date, quantity, truckId, userId, category, billPictures, warehouseId } = getValues();

    const formData = {
      date,
      quantity,
      truckId,
      userId,
      category,
      inventoryOutTransactionPictures: billPictures || [],
      warehouseId,
    };
    const request = isEdit ? PUT(`inventory/out-inside-transaction/${id}`, formData, {}, true) : POST("inventory/out-inside-transaction", formData, {}, true);

    request
      .then(({ data }) => {
        if (isEdit) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
          history.push(`/inventory-out-inside/${data.id}`);
        }
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const genScanQRData = () => {
    const data = JSON.stringify({
      action: ACTION_SCAN.OIL_OUT_INSIDE_TRANSACTION,
      data: {
        id,
      },
    });

    return Buffer.from(data).toString("base64");
  };

  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đổ dầu</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div className="p-2">
                <h5 className="title">{isEdit ? "Sửa" : "Thêm"}</h5>
                <div className="mt-4">
                  <FormProvider {...methodForm}>
                    <form onSubmit={handleSubmit(onHandleSubmit)}>
                      <Row className="g-3">
                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label" htmlFor="customer">
                              Ngày
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="datetime-local"
                                className="form-control"
                                name="date"
                                ref={register({
                                  required: "Vui lòng nhập thông tin",
                                })}
                              />
                              <ErrorMessage errors={errors} name="date" render={({ message }) => <span className="invalid">{message}</span>} />
                            </div>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label">
                              Bản số xe <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="truckId"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect isClearable placeholder="Biển số xe" options={truckOptions} value={truckOptions.find((c) => c.value === value)} onChange={(val) => onChange(val.value)} />
                                )}
                              />
                              <ErrorMessage errors={errors} name="truckId" render={({ message }) => <span className="invalid">{message}</span>} />
                            </div>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label">
                              Tài xế <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="userId"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    isClearable
                                    placeholder="Tài xế"
                                    options={driverOptions}
                                    value={driverOptions.find((c) => c.value === value) || null}
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              />
                              <ErrorMessage errors={errors} name="userId" render={({ message }) => <span className="invalid">{message}</span>} />
                            </div>
                          </div>
                        </Col>


                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label" htmlFor="warehouseId">
                              Kho <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="warehouseId"
                                rules={{ required: "Vui lòng nhập thông tin" }}

                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    isDisabled={isEdit}
                                    isClearable
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={warehouseOptions}
                                    value={warehouseOptions.find(
                                      (c) => c.value === value
                                    ) || null}
                                    onChange={(val) => {
                                      onChange(val?.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="warehouseId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label">
                              Loại <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="category"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    ref={ref}
                                    name={name}
                                    options={INVENTORY_FUEL_CATEGORY_OPTIONS}
                                    isDisabled={isEdit}
                                    value={INVENTORY_FUEL_CATEGORY_OPTIONS.find((c) => c.value === value)}
                                    onChange={(val) => onChange(val?.value)}
                                  />
                                )}
                              />
                              <ErrorMessage errors={errors} name="category" render={({ message }) => <span className="invalid">{message}</span>} />
                            </div>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label" htmlFor="customer">
                              Số lượng
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="quantity"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage errors={errors} name="weight" render={({ message }) => <span className="invalid">{message}</span>} />
                            </div>
                          </div>
                        </Col>
                        {isEdit ? (<Col md={6}>
                          <QRCode size={150} value={genScanQRData()} />
                        </Col>
                        ) : (
                          <></>
                        )}
                        <Col md={12}>
                          <Pictures />
                        </Col>


                        <Col size="12">
                          <Button color="primary" type="submit" disabled={loading}>
                            <span>{isEdit ? "Sửa" : "Thêm"}</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default UpsertInventoryOutInside;
